import React from 'react'

const icon = ({ className, isSelected, onClick }) => (
    <svg onClick={onClick} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8327 1.13798L10.8893 0.195312L6.028 5.05733L1.16599 0.195312L0.222656 1.13798L5.08467 6L0.222656 10.862L1.16599 11.8047L6.028 6.94266L10.8893 11.8047L11.8327 10.862L6.97067 6L11.8327 1.13798Z" fill="#6B4E9F"/>
</svg>

)

export default icon